const setSelectedSearchByAction = ({ commit }, payload) => {
  commit('setSelectedSearchBy', payload)
}
const setTotalTemplateAction = ({ commit }, payload) => {
  commit('setTotalTemplates', payload)
}
const setTotalPresentationAction = ({ commit }, payload) => {
  commit('setTotalPresentations', payload)
}

export default {
  setSelectedSearchByAction,
  setTotalTemplateAction,
  setTotalPresentationAction,
}
